export const dashUiEn = {
  greeting: "Hello, {{name}}",
  guest: "there",
  next: "Next up",
  queue: "Needs your action",
  nothingDue: "Nothing needs you right now",
  noClub: "Choose a club to see this dashboard.",
  open: "Open",
  applications: "Applications",
  sessions: "Sessions",
  payments: "Payments",
  status: "Status",
  when: "When",
  amount: "Amount",
  kpi: {
    applications: "Applications",
    trials: "Trials this week",
    players: "Active players",
    programmes: "Programmes",
    sessions: "Sessions this week",
    posts: "Posts to publish",
    collected: "Collected this month",
    outstanding: "Outstanding",
    overdue: "Overdue",
    rate: "Collection rate",
  },
  nextEmpty: {
    club_admin: "No intake waiting",
    club_manager: "No session on the schedule",
    club_finance: "No billing waiting",
  },
  action: {
    applications: "Review applications",
    schedule: "Open schedule",
    logistics: "Open logistics",
    payments: "Open payments",
    events: "Open events",
    explore: "Explore",
    children: "Open children",
    players: "Open players",
    welfare: "Open welfare",
    posts: "Open posts",
    search: "Search talent",
    assignments: "Open assignments",
    injuries: "Open injuries",
    bookings: "Open bookings",
    tournaments: "Open tournaments",
    approvals: "Open approvals",
    subscriptions: "Open subscriptions",
  },
  q: {
    applications: "Applications to review",
    trials: "Trials this week",
    staff: "Staff list",
    sessions: "Sessions this week",
    posts: "Posts to publish",
    programmes: "Programmes",
    overdue: "Overdue invoices",
    payments: "Payments",
    schedule: "This week",
    players: "Players",
    welfare: "Welfare",
    fees: "Fees",
    events: "Events",
    plans: "Training plans",
    matches: "Matches",
    search: "Talent search",
    shortlists: "Shortlists",
    reports: "Reports",
    assignments: "Assignments",
    results: "Results to enter",
    injuries: "Injuries",
    clearances: "Clearances",
    bookings: "Bookings",
    tournaments: "Tournaments",
    approvals: "Approvals",
    users: "Users",
    moderation: "Moderation",
    subscriptions: "Subscriptions",
    flags: "Feature flags",
  },
  role: {
    fan: "Fan",
    player: "Player",
    parent: "Parent",
    coach: "Coach",
    club_owner: "Club owner",
    club_admin: "Club admin",
    club_manager: "Club manager",
    club_finance: "Club finance",
    team_manager: "Team manager",
    scout: "Scout",
    scouter: "Scouter",
    referee: "Referee",
    medical_staff: "Medical staff",
    venue_owner: "Venue owner",
    tournament_organizer: "Tournament organizer",
    admin: "Admin",
    super_admin: "Super admin",
  },
};

export const dashUiMs = {
  greeting: "Hai, {{name}}",
  guest: "anda",
  next: "Seterusnya",
  queue: "Perlu tindakan anda",
  nothingDue: "Tiada yang memerlukan anda sekarang",
  noClub: "Pilih kelab untuk melihat papan pemuka ini.",
  open: "Buka",
  applications: "Permohonan",
  sessions: "Sesi",
  payments: "Bayaran",
  status: "Status",
  when: "Bila",
  amount: "Amaun",
  kpi: {
    applications: "Permohonan",
    trials: "Percubaan minggu ini",
    players: "Pemain aktif",
    programmes: "Program",
    sessions: "Sesi minggu ini",
    posts: "Siaran untuk diterbitkan",
    collected: "Kutipan bulan ini",
    outstanding: "Tertunggak",
    overdue: "Lewat",
    rate: "Kadar kutipan",
  },
  nextEmpty: {
    club_admin: "Tiada pengambilan yang menunggu",
    club_manager: "Tiada sesi pada jadual",
    club_finance: "Tiada bil yang menunggu",
  },
  action: {
    applications: "Semak permohonan",
    schedule: "Buka jadual",
    logistics: "Buka logistik",
    payments: "Buka bayaran",
    events: "Buka acara",
    explore: "Teroka",
    children: "Buka anak",
    players: "Buka pemain",
    welfare: "Buka kebajikan",
    posts: "Buka siaran",
    search: "Cari bakat",
    assignments: "Buka tugasan",
    injuries: "Buka kecederaan",
    bookings: "Buka tempahan",
    tournaments: "Buka kejohanan",
    approvals: "Buka kelulusan",
    subscriptions: "Buka langganan",
  },
  q: {
    applications: "Permohonan untuk disemak",
    trials: "Percubaan minggu ini",
    staff: "Senarai kakitangan",
    sessions: "Sesi minggu ini",
    posts: "Siaran untuk diterbitkan",
    programmes: "Program",
    overdue: "Invois lewat",
    payments: "Bayaran",
    schedule: "Minggu ini",
    players: "Pemain",
    welfare: "Kebajikan",
    fees: "Yuran",
    events: "Acara",
    plans: "Pelan latihan",
    matches: "Perlawanan",
    search: "Carian bakat",
    shortlists: "Senarai pendek",
    reports: "Laporan",
    assignments: "Tugasan",
    results: "Keputusan untuk diisi",
    injuries: "Kecederaan",
    clearances: "Kebenaran",
    bookings: "Tempahan",
    tournaments: "Kejohanan",
    approvals: "Kelulusan",
    users: "Pengguna",
    moderation: "Moderasi",
    subscriptions: "Langganan",
    flags: "Bendera ciri",
  },
  role: {
    fan: "Peminat",
    player: "Pemain",
    parent: "Ibu bapa",
    coach: "Jurulatih",
    club_owner: "Pemilik kelab",
    club_admin: "Pentadbir kelab",
    club_manager: "Pengurus kelab",
    club_finance: "Kewangan kelab",
    team_manager: "Pengurus pasukan",
    scout: "Pengakap",
    scouter: "Pengakap kontrak",
    referee: "Pengadil",
    medical_staff: "Kakitangan perubatan",
    venue_owner: "Pemilik tempat",
    tournament_organizer: "Penganjur kejohanan",
    admin: "Pentadbir",
    super_admin: "Pentadbir super",
  },
};
